import { Switch } from 'antd';
import styled from 'styled-components';

export const ListWrapper = styled.div`
  display: flex;
  padding: 20px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: rgba(0, 0, 0, 0.04);
`;

export const Card = styled.div`
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 200px;
  overflow-y: auto;
  width: 100%;
  strong {
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    letter-spacing: -0.2px;
  }

  span {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
`;

export const StyledSwitch = styled(Switch)<{ $customColor?: string }>`
  ${({ $customColor }) =>
    $customColor &&
    `
    &.ant-switch-checked { background-color: ${$customColor}; }
    &.ant-switch-checked:hover:not(.ant-switch-disabled) { background: ${$customColor}; }
  `}
`;
